<mat-toolbar class="navbar">   
  <button mat-icon-button class="menu-button" (click)="toggleSidenav()">
    <mat-icon>menu</mat-icon>
  </button>

  <a routerLink="/home">
    <img src="../../../assets/images/Logo.png" class="logo">
  </a>

  <span class="example-spacer"></span>

  <!-- <a href="https://healthpossibleinc.org/join-now/" class="link-styling">JOIN NOW</a>
  <a href="https://healthpossibleinc.org/whoweare/" class="link-styling">WHO WE ARE</a>
  <a href="https://healthpossibleinc.org/about/" class="link-styling">OUR TEAM</a>
  <a href="https://healthpossibleinc.org/contact/" class="link-styling">CONTACT</a>
  <a href="https://healthpossibleinc.org/donate-2/" class="link-styling">DONATE</a> -->
  <div class="icon-div">

    @if (notificationsCount > 0 && isUserLoggedIn) {
      <mat-icon style="color: red;" (click)="navigateToNotificationsManagement()" class="clickable">notifications_active</mat-icon>
    }
    @if (notificationsCount == 0 && isUserLoggedIn) {
      <mat-icon (click)="navigateToNotificationsManagement()" class="clickable">
      notifications</mat-icon>
    }
    @if (notificationsCount > 0 && isUserLoggedIn) {
      <span style="color: red;">{{ notificationsCount }}</span>
    }

    <mat-icon (click)="navigateToCheckout()" class="clickable ml-3">shopping_cart</mat-icon>
    @if (itemCount > 0) {
      <span style="color: red;">{{ itemCount }}</span>
    }
  </div>
</mat-toolbar>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="opened" style="border-radius: 0px">
    <mat-nav-list>
      <a style="border-radius: 0px" mat-list-item href="{{upperNewsLink}}">About</a>
      @for (route of routes | keyvalue; track route) {
        <a
          mat-list-item
          [routerLink]="route.key"
          style="border-radius: 0px"
          class="mat-mdc-list-item active-link"
          routerLinkActive="active-link"
        >
          <span class="mat-mdc-list-item__primary-text">{{route.value}}</span>
        </a>
      }
      
      @if (isUserLoggedIn) {
        <a 
          style="border-radius: 0px" 
          mat-list-item routerLink="notifications-management" 
          class="mat-mdc-list-item active-link"
          routerLinkActive="active-link"
          >
          <span class="mat-mdc-list-item__primary-text">Notifications</span>
        </a>
      }
      
      @if (isUserLoggedIn) {
        <a 
          style="border-radius: 0px" 
          mat-list-item 
          routerLink="subscription-management" 
          routerLinkActive="active-link">
          <span class="mat-mdc-list-item__primary-text">Subscriptions</span>
        </a>
      }
    </mat-nav-list>

    @if (isUserLoggedIn) {
      <button mat-flat-button style="border-radius: 0px" class="logout-button" (click)="logout()" color="secondary">Logout</button>
    }
    @if (!isUserLoggedIn) {
      <button mat-flat-button style="border-radius: 0px" class="logout-button" (click)="logInScreen()" color="secondary">Login</button>
    }
  </mat-sidenav>

  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>